import { render } from "./CalculateHPB.vue?vue&type=template&id=05b6d717&scoped=true"
import script from "./CalculateHPB.vue?vue&type=script&lang=js"
export * from "./CalculateHPB.vue?vue&type=script&lang=js"

import "./CalculateHPB.vue?vue&type=style&index=0&id=05b6d717&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b6d717"]])

export default __exports__